// Debounce function definition
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    const context = this;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

class ProductFilterForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.priceRangeValues = {}; // Store range values here
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 1000);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    window.addEventListener('popstate', this.onHistoryChange.bind(this));
    this.displayFilters();
  }

  // onSubmitHandler(event) {
  //   event.preventDefault();
  //   const formData = new FormData(event.target.closest('form'));
  //   const searchParams = new URLSearchParams(formData).toString();
  //   this.renderPage(searchParams, event);
  // }

  onSubmitHandler(event) {
    event.preventDefault();
  
    const form = event.target.closest('form');
    const formData = new FormData(form);
  
    // Remove price range fields if on search page
    if (window.location.pathname.includes('/search')) {
      formData.delete('filter.v.price.gte');
      formData.delete('filter.v.price.lte');
    }
  
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.toggleActiveFilters();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFilters(disable = true) {
    document.querySelectorAll('.js-filter-remove').forEach((element) => {
      element.classList.toggle('hidden', disable);
    });
    this.displayFilters();
  }

  renderPage(searchParams, event, updateURLHash = true) {
    const priceRangeSlider = document.querySelector('price-range-slider');
    if (priceRangeSlider) {
      this.priceRangeValues.min = priceRangeSlider.querySelector('.min-input').value;
      this.priceRangeValues.max = priceRangeSlider.querySelector('.max-input').value;
    }
  
    const sections = this.getSections();
    document.querySelector('[collection-loader]').classList.remove('invisible', 'opacity-0');
  
    sections.forEach((section) => {
      // Preserve current search params and filter out unwanted ones
      const baseSearchParams = new URLSearchParams(searchParams);
  
      // If current page is a search page and has a q param, preserve it
      if (window.location.pathname.includes('/search')) {
        const currentSearch = new URLSearchParams(window.location.search);
        const query = currentSearch.get('q');
        if (query) baseSearchParams.set('q', query);
      }
  
      // Remove unwanted param like options[prefix]=last
      baseSearchParams.delete('options[prefix]');
  
      // Add the section_id to the search params
      baseSearchParams.set('section_id', section.section);
  
      // Build the final URL for fetching
      const url = `${window.location.pathname}?${baseSearchParams.toString()}`;
  
      const filterDataUrl = (element) => element.url === url;
  
      this.filterData.some(filterDataUrl)
        ? this.renderSectionFromCache(filterDataUrl, event)
        : this.renderSectionFromFetch(url, event);
    });
  
    if (updateURLHash) this.updateURLHash(searchParams);
  }


  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];
        this.renderFilters(html, event);
        this.renderProductGrid(html);
      })
      .then(() => {
        document.querySelector('[collection-loader]').classList.add('invisible', 'opacity-0');
      });
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderFilters(html, event);
    this.renderProductGrid(html);
    document.querySelector('[collection-loader]').classList.add('invisible', 'opacity-0');
  }

  renderProductGrid(html) {
    document.querySelector('#main-collection-wrapper').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('#main-collection-wrapper').innerHTML;
  }

  renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const currentFilterOptionsMain = this.querySelector('[data-filter-main]');
    const renderedFilterOptionsMain = parsedHTML.querySelector('[data-filter-main]');

    currentFilterOptionsMain.innerHTML = renderedFilterOptionsMain.innerHTML;

    // Restore the stored range values after HTML re-render
    const priceRangeSlider = document.querySelector('price-range-slider');
    if (priceRangeSlider) {
      priceRangeSlider.querySelector('.min-input').value = this.priceRangeValues.min;
      priceRangeSlider.querySelector('.max-input').value = this.priceRangeValues.max;

      priceRangeSlider.querySelector('.min-range').value = this.priceRangeValues.min;
      priceRangeSlider.querySelector('.max-range').value = this.priceRangeValues.max;

      // Update the visual elements after restoring values
      priceRangeSlider.updateVisuals();
    }

    this.renderActiveFilters(parsedHTML);
  }

  renderActiveFilters(html) {
    const activeFilterElementIdentifier = '[data-filter-current]';
    const currentActiveFiltersHeaderElement = document.querySelector(activeFilterElementIdentifier);
    const renderedActiveFilterElement = html.querySelector(activeFilterElementIdentifier);
    if (!renderedActiveFilterElement) return;

    currentActiveFiltersHeaderElement.outerHTML = renderedActiveFilterElement.outerHTML;

    this.displayFilters();
    this.toggleActiveFilters(false);
  }

  displayFilters() {
    // Update the filter label counter
    const filterFormNets = document.querySelector('[data-filter-form-nets]');
    const activeFilters = document.querySelector('[data-filter-current] [data-filter-list]').children;
    const filterClearAll = document.querySelector('[data-filter-clear-all]');

    if (!filterFormNets) {
      if (activeFilters.length <= 0) filterClearAll.classList.add('hidden');
    } else {
      filterClearAll.classList.add('hidden');
    }

    // Check all filters and hide the ones with no options
    const filterLists = document.querySelectorAll('[data-filter-list]');
    filterLists.forEach((list) => list.children.length === 0
      ? list.closest(".js-filter").classList.add("hidden")
      : list.closest(".js-filter").classList.remove("hidden"));
  }

  // updateURLHash(searchParams) {
  //   history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  // }

  updateURLHash(searchParams) {
    const currentUrl = new URL(window.location.href);
    const currentSearchParams = new URLSearchParams(currentUrl.search);
    const newSearchParams = new URLSearchParams(searchParams);
  
    // Merge new filters into current query string
    newSearchParams.forEach((value, key) => {
      currentSearchParams.set(key, value); // override or add
    });
  
    const newUrl = `${window.location.pathname}?${currentSearchParams.toString()}`;
    history.pushState({ searchParams: currentSearchParams.toString() }, '', newUrl);
  }

  getSections() {
    return [
      {
        id: 'main-collection',
        section: document.getElementById('main-collection').dataset.id,
      }
    ];
  }
}

if (!customElements.get('product-filter-form')) {
  customElements.define('product-filter-form', ProductFilterForm);
}

class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();
    this.minInput = this.querySelector('.min-input');
    this.maxInput = this.querySelector('.max-input');
    this.minRange = this.querySelector('.min-range');
    this.maxRange = this.querySelector('.max-range');
    this.rangeFill = this.querySelector('.range-slider .range');

    this.initializeFromDataAttributes();

    // Attach event listeners
    this.minRange.addEventListener('input', (e) => this.onMinChange(e));
    this.maxRange.addEventListener('input', (e) => this.onMaxChange(e));
    this.minInput.addEventListener('input', () => this.onMinChange());
    this.maxInput.addEventListener('input', () => this.onMaxChange());

    this.updateVisuals();
  }

  initializeFromDataAttributes() {
    this.minInput.value = this.minRange.value = this.minInput.getAttribute('data-attribute-custom-value') || 0;
    this.maxInput.value = this.maxRange.value = this.maxInput.getAttribute('data-attribute-custom-value') || 100;
  }

  onMinChange() {
    let minValue = Number(this.minRange.value);
    let maxValue = Number(this.maxRange.value);

    // Prevent overlap
    if (minValue >= maxValue - 1) {
      minValue = maxValue - 1;
      this.minRange.value = minValue;
    }

    this.minInput.value = minValue;

    // Adjust z-index dynamically (important fix)
    this.minRange.style.zIndex = "5";
    this.maxRange.style.zIndex = "4";

    this.updateVisuals();
  }

  onMaxChange() {
    let minValue = Number(this.minRange.value);
    let maxValue = Number(this.maxRange.value);

    // Prevent overlap
    if (maxValue <= minValue + 1) {
      maxValue = minValue + 1;
      this.maxRange.value = maxValue;
    }

    this.maxInput.value = maxValue;

    // Adjust z-index dynamically
    this.minRange.style.zIndex = "4";
    this.maxRange.style.zIndex = "5";

    this.updateVisuals();
  }

  updateVisuals() {
    const minPercent = ((this.minRange.value - this.minRange.min) / (this.minRange.max - this.minRange.min)) * 100;
    const maxPercent = ((this.maxRange.value - this.minRange.min) / (this.maxRange.max - this.minRange.min)) * 100;

    this.rangeFill.style.left = `${minPercent}%`;
    this.rangeFill.style.width = `${maxPercent - minPercent}%`;
  }
}

if (!customElements.get('price-range-slider')) {
  customElements.define('price-range-slider', PriceRangeSlider);
}


class OptionRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('product-filter-form') || document.querySelector('product-filter-form');
      form.onActiveFilterClick(event);
    });
  }
}

if (!customElements.get('filter-remove')) {
  customElements.define('filter-remove', OptionRemove);
}